import { LinkButton as DotLinkButton } from '@dot/design-system';
import { default as styled } from 'styled-components';

export const Header = styled.header`
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 60px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    height: 80px;
  }
`;

export const LogoWrapper = styled.div`
  width: 120px;
  height: 40px;
  overflow: hidden;
  object-fit: cover;

  @media (min-width: ${(p) => p.theme.devices.mobileL}) {
    width: 200px;
  }

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    width: 300px;
  }

  & > svg,
  & > img {
    display: block;
    width: 100%;
    height: 40px;
    object-fit: contain;
    object-position: left center;
  }
`;

export const LinkButton = styled(DotLinkButton)`
  color: ${(p) => p.theme.colors.oxfordBlue[50]};
  display: flex;
  align-items: center;
  padding: 0 0.125rem;

  gap: 0.25rem;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    gap: 0.625rem;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const ButtonText = styled.span`
  white-space: nowrap;
`;

export const ButtonIconWrapper = styled.div`
  & > svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`;
